import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/cloudversify': {
    width: 616,
    height: 512,
    paths: [
      {
        d: 'M148.6 304v0.1h-48.9c-6.4 0-11.7-5.4-11.7-11.8v-40.4c0-7.6 7-11.9 10.8-11.9h46.8v6.6c0 10.7 8.8 16.7 19.5 16.7h20.2c10.8 0 19.5-8.8 19.5-19.5v-20.4c0-10.6-3.5-19.5-15.2-19.5 18.5-15.2 37.2-21.4 45-24.1 15-56.5 42-92.4 99.3-109.7 55.1-16.5 153.5-3.1 186.5 85 73.9 22.6 106.9 92.6 92.1 155.1-13 54.9-62.3 100.6-131.5 99.5-49.6 51.4-135.2 48.9-186.4 5.6-78.6 4.2-137.8-42.8-146-111.3zM376 312c8.7 54.1 59.7 65.5 91.8 59.2 39.1-7.7 70.5-37.5 79.7-76.5 5.8-24.4 2.4-50-9.4-72l-10.5-19.6c1.2 22.5-12.5 60.6-47.5 76.9 65.5-67.7 2.1-141.2-67.7-150.5-49.8-6.6-83.3 13-114.2 43.7 48 4.7 87.7 26.8 101.8 74.8-30.1-49.3-103-56.6-133.6-40.8-35.5 18.2-60 54-57 93.9 3.6 47.4 39.5 67.4 57.4 79.8-4.5-21.7-4-71.3 29.2-92.9-36.3 60 28.1 144.6 135.3 110.8-33.6-14.4-66-40.5-55.3-86.8zM128 208h-39.8c-8.9 0-16.2-7.3-16.2-16.2v-39.6c0-8.9 7.3-16.2 16.2-16.2h39.8c8.9 0 16.2 7.3 16.2 16.2v39.6c0 8.9-7.3 16.2-16.2 16.2zM10.1 168c-5.6 0-10.1-4.5-10.1-10.1v-27.8c0-5.6 4.5-10.1 10.1-10.1h27.7c5.5 0 10.1 4.5 10.1 10.1v27.8c0 5.6-4.5 10.1-10.1 10.1h-27.7zM168 142.7v-21.4c0-5.1 4.2-9.3 9.3-9.3h21.4c5.1 0 9.3 4.2 9.3 9.3v21.4c0 5.1-4.2 9.3-9.3 9.3h-21.4c-5.1 0-9.3-4.2-9.3-9.3zM56 235.5v25c0 6.3-5.1 11.5-11.4 11.5h-25.2c-6.3 0-11.4-5.2-11.4-11.5v-25c0-6.3 5.1-11.5 11.4-11.5h25.1c6.4 0 11.5 5.2 11.5 11.5z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/cloudversify.js
// module id = 759
// module chunks = 0